import { render } from "./BaseRightBar.vue?vue&type=template&id=6fe9f7fa&scoped=true"
import script from "./BaseRightBar.vue?vue&type=script&lang=js"
export * from "./BaseRightBar.vue?vue&type=script&lang=js"

import "./BaseRightBar.vue?vue&type=style&index=0&id=6fe9f7fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe9f7fa"]])

export default __exports__